import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { setHamkariDavat, GetHamkariData } from "../axios";
import { useLocation } from "react-router-dom";

const RegistrationOfCooperation = () => {
  const [formValue, setFormValue] = useState({
    phone: "",
    name: "",
    text: "",
  });

  const changeHandler = ({ target }) => {
    setFormValue((prevState) => {
      return {
        ...prevState,
        [target.name]: target.value,
      };
    });
  };

  const [HamkariData, setHamkariData] = useState({});
  useEffect(() => {
    try {
      GetHamkariData().then(({ data }) => {
        setHamkariData(data[0]);
      });
    } catch (error) {
      console.log(error.message);
    }
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    if (
      formValue.name === "" ||
      (formValue.name === "") | (formValue.text === "")
    ) {
      toast.error("پر کردن همه ی فیلد ها الزامیست.");
    } else {
      setHamkariDavat(formValue.phone, formValue.name, formValue.text)
        .then((res) => {
          if (res.data === "1") {
            toast.success("درخواست با موفقیت ثبت شد.");
          } else {
            toast.error("ثبت درخواست با مشکل مواجه شد");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      setFormValue({
        phone: "",
        name: "",
        text: "",
      });
    }
  };

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <div className="shop_area shop_reverse mt-60 mb-60">
      <div className="row">
        <div className=" col-md-12" style={{ float: "none", margin: "auto" }}>
          <div className="container-lg">
            <h4>ثبت درخواست همکاری</h4>
            <img
              className="border shadow-sm rounded-2"
              src={HamkariData.aks}
              alt="Moshavereh_aks"
              style={{ height: "100%", width: "100%", objectFit: "fill" }}
            />
          </div>
          <div className="container col-lg-5 col-md-12">
            <p className="mt-2" style={{ whiteSpace: "pre-line" }}>
              {HamkariData.matn}
            </p>
            <div className="mt-4">
              <label>اسم</label>
              <input
                type="text"
                onChange={changeHandler}
                id="name"
                name="name"
                value={formValue.name}
                className="form-control"
              />
            </div>
            <div className="mt-4">
              <label>شماره تماس</label>
              <input
                type="number"
                onChange={changeHandler}
                id="phone"
                name="phone"
                value={formValue.phone}
                className="form-control"
              />
            </div>
            <div className="mt-4">
              <label>زمینه همکاری </label>
              <input
                type="text"
                onChange={changeHandler}
                id="text"
                name="text"
                value={formValue.text}
                className="form-control"
              />
            </div>
            <div className="mt-4">
              <button onClick={submitHandler} className="btn btn-success">
                ثبت درخواست همکاری
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationOfCooperation;
